export const ANIMATION_SPEED = 500;
